<template>
  <div class="tabs">
    <transition name="el-zoom-in-center">
      <img src="../assets/images/bottom_erweima.png"
           class="icon-tabs-erweima"
           v-show="isshow == true">
    </transition>
    <div class="header-tabs">
      <router-link class="tab-home htc-tag-on"
                   to='/'>
        <div class="view-home-tab">
          <img class="img-logo"
               src="../../src/assets/images/logo.png" />
          <img class="img-logo-bt"
               v-if="activeIndex == 0 "
               src="../../src/assets/images/icon_down.png" />
        </div>

      </router-link>

      <div class="tabs-top-text">
        <div class="tv-left"
             style="margin-left: 5%;">以人为本 生命至上</div>
        <div class="tv-right-content">
          <router-link class="tv-left"
                       to='/'>返回首页</router-link>
          <div class="tv-left">｜</div>
          <div class="tv-left"
               @mouseover="isshow = true"
               @mouseout="isshow = false"> 扫描预约挂号</div>
        </div>

      </div>
      <div class="tab-bottom-tabs htc-tags">
        <router-link class="width25 htc-tag"
                     :class="{'htc-tag-on':activeIndex == 1}"
                     to='/department'>科室介绍</router-link>
        <router-link class="width25 htc-tag"
                     :class="{'htc-tag-on':activeIndex == 2}"
                     to='/expert'>本院专家</router-link>
        <router-link class="width25 htc-tag"
                     :class="{'htc-tag-on':activeIndex == 3}"
                     to='/device'>医疗设备</router-link>
        <router-link class="width25 htc-tag"
                     :class="{'htc-tag-on':activeIndex == 4}"
                     to='/honor'>荣誉资质</router-link>
        <div style="width: 260px;"></div>
        <router-link class="width25 htc-tag"
                     :class="{'htc-tag-on':activeIndex == 5}"
                     to='/news'>新闻实事</router-link>
        <router-link class="width25 htc-tag"
                     :class="{'htc-tag-on':activeIndex == 6}"
                     to='/overview'>医院概况</router-link>
        <router-link class="width25 htc-tag"
                     :class="{'htc-tag-on':activeIndex == 7}"
                     to='/recruit'>招聘信息</router-link>
        <router-link class="width25 htc-tag"
                     :class="{'htc-tag-on':activeIndex == 8}"
                     to='/contacUs'>联系我们</router-link>
      </div>
      <div class="dv-top-view">
        <div class="tv-top-left">DALIAN LIAO YU HOSPITAL</div>
        <div class='dv-top-right-view'>
          <img src="../assets/images/icon_home_phone.png"
               class="img-top-phone">
          {{ info.telephone }}
        </div>
      </div>

      <!-- <div class="width-min box box-pack-between header-tabs-content">
				<router-link id="logo" to='/' class="htc-item">
					<img class="htci-logo" src="../assets/images/logo.png" />
				</router-link>
				<div class="box box-pack-between htc-tags">
					<router-link class="width25 htc-tag" :class="{'htc-tag-on':activeIndex == 0}" to='/'>首页</router-link>
					<router-link class="width25 htc-tag" :class="{'htc-tag-on':activeIndex == 1}" to='/expert'>学术团队</router-link>
					<router-link class="width25 htc-tag" :class="{'htc-tag-on':activeIndex == 2}" to='/vip'>会员专享</router-link>
					<router-link class="width25 htc-tag" :class="{'htc-tag-on':activeIndex == 3}" to='/news'>资讯动态</router-link>
					<router-link class="width25 htc-tag" :class="{'htc-tag-on':activeIndex == 4}" to='/feedback'>在线反馈</router-link>
				</div>
			</div> -->
    </div>
  </div>
</template>

<script>
import api from '../api/api'
export default {
  name: 'tabs',
  props: {
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  //可以监听data props值得变化
  watch: {

    tabIndex (newVal) {
      this.activeIndex = newVal

      // console.log(newVal)
    }
  },
  created () {
    this.contactdetail()
  },
  data () {
    return {
      activeIndex: 0,
      isshow: false,
      info: '',
    }
  },
  methods: {
    homeFun () {
      console.log(this.msg)
    },
    //招聘信息列表
    contactdetail () {
      let parm = {
        FKEY: api.getFKEY(),

      }
      api.contactdetail(parm).then((res) => {
        this.info = res.data
        console.log('返回' + res.data)
      })
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  display: -webkit-box;
  /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
  display: -moz-box;
  /* 老版本语法: Firefox (buggy) */
  display: -ms-flexbox;
  /* 混合版本语法: IE 10 */
  display: -webkit-flex;
  /* 新版本语法: Chrome 21+ */
  display: flex;
  /* 新版本语法: Opera 12.1, Firefox 22+ */
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

/*主轴左右不留白*/

.box-pack-between {
  -webkit-box-pack: justify;
  -moz-justify-content: space-between;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.width25 {
  width: 140px;
  height: 85px;
}

.htc-item:hover {
  cursor: pointer;
}

.header-tabs {
  position: fixed;
  left: 0;
  top: 0;
  /* background-color: #3875F6; */
  width: 100%;
  height: 140px;
  line-height: 140px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  z-index: 10;
}

.header-tabs-content {
  margin: 0 auto;
}

.htci-logo {
  width: 133.2px;
  vertical-align: middle;
}

.htc-tags {
  position: relative;
}

.htc-tag {
  width: 140px;
  height: 65px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
  line-height: 65px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-decoration: none;
}

.htc-tag:hover {
  background-color: #f3eefe;
}

.htc-tag-on {
  color: #ffffff;
  background-color: #8271ae;
  font-size: 20px;
  border-bottom: 9px #e2c48f solid;
  box-sizing: border-box;
}

.htc-tag-on:hover {
  background-color: #6f4c9f;
}

.htc-tag:hover {
  cursor: pointer;
}

.htc-img {
  position: absolute;
  left: 12.5%;
  bottom: 0;
  width: 4.5rem;
  transform: translateX(-2.25rem);
}

.blue-color {
  background-color: #3875f6;
}
@media screen and (max-width: 1099px) {
  .htc-item {
    padding-left: 50px;
  }
}
.tabs-top-text {
  width: 100%;
  height: 35px;
  border-bottom: 1px #e6e6ef solid;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.tv-left {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  line-height: 35px;
  color: #5d6077;
}
.tv-right-content {
  height: 35px;
  display: flex;
  margin-right: 5%;
  flex-direction: row;
}
.tab-bottom-tabs {
  width: 100%;
  height: 65px;
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
}
.tab-home {
  width: 190px;
  height: 160px;
  position: fixed;
  z-index: 10;
  margin-left: calc(50% - 95px);
  background: #8271ae;
}
.view-home-tab {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-logo {
  width: 90px;
  height: 90px;
  margin-top: 20px;
}
.img-logo-bt {
  width: 20px;
  height: 20px;
  margin-top: 10px;
}
.dv-top-view {
  background: url("../assets/images/icon_home_1.png");
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.tv-top-left {
  font-size: 18px;
  font-family: STZhongsong, STZhongsong-Regular;
  font-weight: 400;
  text-align: left;
  line-height: 40px;
  margin-left: 24%;
  color: #ffffff;
}
.dv-top-right-view {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 24%;
  line-height: 40px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #ffffff;
}
.img-top-phone {
  width: 150px;
  height: 28px;

  margin-right: 10px;
}
.icon-tabs-erweima {
  width: 160px;
  position: fixed;
  top: 60px;
  right: 80px;
  z-index: 10000;
}
</style>
